/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Help_CenterInputs */

const en_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Center`)
};

const de_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfecenter`)
};

const fr_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre d'aide`)
};

const es_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de ayuda`)
};

const it_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro assistenza`)
};

const nl_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpcentrum`)
};

const pl_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum pomocy`)
};

const fi_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohje`)
};

const da_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjælpecenter`)
};

const sv_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjälpcenter`)
};

/**
* | output |
* | --- |
* | "Help Center" |
*
* @param {Nav_Help_CenterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_help_center = /** @type {((inputs?: Nav_Help_CenterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Help_CenterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_help_center(inputs)
	if (locale === "fr") return fr_nav_help_center(inputs)
	if (locale === "es") return es_nav_help_center(inputs)
	if (locale === "it") return it_nav_help_center(inputs)
	if (locale === "nl") return nl_nav_help_center(inputs)
	if (locale === "pl") return pl_nav_help_center(inputs)
	if (locale === "fi") return fi_nav_help_center(inputs)
	if (locale === "da") return da_nav_help_center(inputs)
	if (locale === "sv") return sv_nav_help_center(inputs)
	return en_nav_help_center(inputs)
});